import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ExpandIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color ?? '#0058AD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.425 8.818 22.607 12m0 0-3.182 3.182M22.607 12H14.12m-9.546 3.182L1.393 12m0 0 3.182-3.182M1.393 12H9.88"
    />
  </Svg>
);
export default ExpandIcon;
